import React, {Component} from 'react';

class RawHtml extends Component {
    render() {
        return <span dangerouslySetInnerHTML={{__html: this.props.children}}/>;
    }
}

export default RawHtml;
